/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useRef, useState } from "react";

import type { Scrollbar as BaseScrollbar } from "smooth-scrollbar/scrollbar";

// import ComponentScrollbar from '@base-components/ComponentScrollbar';
import Typography from "../Typography";

import { Col, Row } from "../Flex";

import useRefs from "helpers/hooks/useRefs";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { useMediaQuery } from "context/media/MediaContext";

import { TabItem, TabProps } from "./Tab.constants";
import {
  StyledOuterContainer,
  StyledTabContainer,
  StyledTabHeader,
  StyledTabInfo,
  StyledTabItemContainer,
  StyledVerticalLine,
} from "./Tab.styles";

const Tab: FC<TabProps> = ({ tabList, onTabChange, width }) => {
  const scrollBarRef = useRef<BaseScrollbar | null>(null);
  const { getRefs, setRef } = useRefs<HTMLButtonElement>();

  const { isMobile } = useMediaQuery();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [innerContainerWidths, setInnerContainerWidths] = useState<number[]>(
    []
  );

  const stepRefs = getRefs();

  const setCurrentTab = (index: number): void => setCurrentIndex(index);

  const scrollOffSet = innerContainerWidths
    .slice(0, currentIndex)
    .reduce((previous: number, current: number) => previous + current, 0);

  // scrollBarRef?.current &&
  //   scrollBarRef?.current?.scrollTo(scrollOffSet + 10 * currentIndex, 0);

  useEffect(() => {
    if (stepRefs?.current) {
      stepRefs?.current?.forEach((element) => {
        setInnerContainerWidths((prevState: number[]) => [
          ...prevState,
          element.clientWidth,
        ]);
      });
    }
  }, [stepRefs]);

  return (
    <>
      <StyledTabContainer
        onTouchEnd={(e) => {
          e.stopPropagation();
        }}
      >
        {/* <ComponentScrollbar marginBottom={isMobile ? 5 : 0} ref={scrollBarRef}> */}
        <StyledOuterContainer>
          <Row flexWrap='no-wrap' padding='3px 0 0 0' noMargin>
            {tabList?.map((tab: TabItem, index: number) => (
              <StyledTabHeader
                key={tab.tabHeader}
                isCurrentTab={currentIndex === index}
                onClick={() => {
                  if (currentIndex !== index) {
                    setCurrentTab(index);

                    onTabChange && onTabChange(index);
                  }
                }}
                ref={(element) => {
                  if (element) setRef(element, index);
                }}
                width={(innerContainerWidths[index] + 10).toString()}
              >
                <Typography
                  color={DIGIPOSTHEME.colors.white}
                  size={isMobile ? "12px" : "14px"}
                  variant='span'
                  weight='500'
                >
                  {tab.tabHeader}
                </Typography>
              </StyledTabHeader>
            ))}
            <StyledVerticalLine
              left={`${scrollOffSet + 10 * currentIndex}`}
              width={`${innerContainerWidths[currentIndex] + 10}`}
            />
          </Row>
        </StyledOuterContainer>
        {/* </ComponentScrollbar> */}
      </StyledTabContainer>

      <StyledTabItemContainer>
        {tabList?.map(
          (tab: TabItem, index: number) =>
            index === currentIndex && (
              <Col key={tab.tabHeader}>
                <StyledTabInfo>{tab.tabInfo}</StyledTabInfo>

                {tab.tabElement()}
              </Col>
            )
        )}
      </StyledTabItemContainer>
    </>
  );
};

export default Tab;
